import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { LaunchDarklyFlags } from '@models/feature-flag.enum';
import { AuthImpurePipe } from '@pipes/auth.pipe';
import { FeatureFlagService } from '@services/feature-flag.service';
import { ModalService } from '@services/modal.service';
import { SecurityContextService } from '@services/security_context.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'sidebar',
  imports: [RouterLink, AuthImpurePipe, CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.less',
})
export class SidebarComponent implements OnInit, AfterViewInit {
  // Constants
  firstname = '';
  lastname = '';
  user = undefined;

  private featureFlagService = inject(FeatureFlagService);

  isAdminListAvaialable$!: Observable<boolean>;
  sageSalesforceIntegration$!: Observable<boolean>;

  constructor(
    private _router: Router,
    private _modalService: ModalService,
    private _securityContextService: SecurityContextService,
  ) {}

  // Lifecycle Hooks
  ngOnInit(): void {
    this.firstname =
      this._securityContextService.get('authDataAdmin')?.firstname || '';
    this.lastname =
      this._securityContextService.get('authDataAdmin')?.lastname || '';
    this.user = this._securityContextService.authData();

    /**
     * sidebar is started after the authentication
     */
    this.featureFlagService.initializeLaunchDarkly(
      this._securityContextService.authData(),
    );

    this.isAdminListAvaialable$ = this.featureFlagService.getFlag(
      LaunchDarklyFlags.ADMIN_LIST,
    );
    this.sageSalesforceIntegration$ = this.featureFlagService.getFlag(
      LaunchDarklyFlags.SAGE_SALESFORCE_INTEGRATION,
    );
  }

  ngAfterViewInit(): void {
    /**
     * TECHNICAL NOTE
     * Homer is based on jquery and relies on DOM readiness, should be callsed afterViewInit
     * ngIf, @if, ngFor etc - are structural directives updating the DOM, homer does not catch them in time
     * Adding the menu element conditional (other then user condition, which handles properly since you get it earlier):
     *   add class="collapse" and aria-expanded="false" to hide the menu item
     */
    homer(); // This runs a bunch of jquery to make the sidebar a jquery metismenu
  }

  // Functions
  logout = () => {
    this._securityContextService.logout();
    this._router.navigate(['']);
  };

  workshopAccounts = async () => {
    try {
      const response = await this._modalService.open('workshopAccounts', {});
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  setupWorkshopAccounts = async () => {
    try {
      const response = await this._modalService.open(
        'workshopAccountSetup',
        {},
      );
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  workshopPasswords = async () => {
    try {
      const response = await this._modalService.open('workshopPasswords', {});
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };
}
